import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
		prepaid: [],
		payment: {},
		paymentlist: {},
		loading: false,
		smsList: [] //短信发送记录
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
    },
	actions: {
        // 获取短息充值套餐列表
		async getPrepaid({ commit }: any) {
			const res = await fetch({
				url: '/client/prepaid'
			})
            commit('setState',{key:'prepaid',data: res})
            
		},
		// 短信费充值
		async smsRecharge({ commit }: any, params: any) {
			const res = await fetch({
				url: '/client/payment/smsRecharge',
				method: 'post',
				data: params
			})
			commit('setState',{key:'payment',data: res})
		},
		// 短信费充值支付宝
		async alipaySmsRecharge({ commit }: any, params: any) {
			const res = await fetch({
				url: '/common/alipay/precreate',
				method: 'post',
				data: params
			})
			commit('setState',{key:'payment',data: res})
		},
		// 解析地址
		async addressResolve({}, params){
			return await fetch({
				url: '/common/addressResolve',
				params,
			})
		},
		// 短信费充值记录
		async getSmsRechargeList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/client/iforder',
				params
			})
			commit('setState',{key:'paymentlist',data: res})
			commit('setState',{key:'loading',data: false})
		},
		// 短信发送记录
		async getsmsList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/client/smsInventory',
				params
			})
			commit('setState',{key:'smsList',data: res})
			commit('setState',{key:'loading',data: false})
		},
	}
}